import NewAuthLayout from '../layout/Layout';
import TenantLogin from '../Components/TenantLogin';
import React, { useEffect, useState } from 'react';
import { useStores } from 'Hooks/useStore';

interface LoginProps {
	isAdminLogin: boolean;
	setShouldMoveToTermsAndConditions: React.Dispatch<
		React.SetStateAction<boolean>
	>;
	firstTimeSignIn?: boolean;
}

export default function Login({
	isAdminLogin,
	setShouldMoveToTermsAndConditions,
	firstTimeSignIn
}: LoginProps) {
	const [showResetPassModal, setShowResetPassModal] = useState(false);
	const { authStore } = useStores();

	useEffect(() => {
		if (authStore.currentUser?.isConsentGiven === false) {
			setShouldMoveToTermsAndConditions(true);
		}
		// do not include `setCognitoUser, setShouldMoveToTermsAndConditions`
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [authStore.currentUser?.isConsentGiven]);

	return (
		<NewAuthLayout
			variant={'split'}
			showPortalBtn={isAdminLogin}
			showResetPassModal={showResetPassModal}
			setShowResetPassModal={setShowResetPassModal}
		>
			{!isAdminLogin && (
				<TenantLogin
					setShowResetPassModal={setShowResetPassModal}
					firstTimeSignIn={firstTimeSignIn}
				/>
			)}
		</NewAuthLayout>
	);
}
